import { render, staticRenderFns } from "./rules-view-form.vue?vue&type=template&id=5326f30c&"
import script from "./rules-view-form.vue?vue&type=script&lang=js&"
export * from "./rules-view-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports